<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf = "usuario && usuario.sucesso" class="supercombo-modal panel panel-default form-filtrar form-default" [ngClass]="usuario.retorno.aparencia">
    <h1>Seleção de Veículos</h1>
    <button type="button" mat-icon-button style="top: -10px; right: -10px; position: absolute;" matTooltip="Fechar" (click)="fechar()">
        <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
        </mat-icon>
    </button>
    <form (ngSubmit)="onSubmit()" #filtroForm="ngForm" class="panel-body">
        <div class="input-group">
            <label class="center-block">
                Pesquisar por
            </label>
            <div class="input-group"></div>
            <mat-select [(ngModel)]="filtro.coluna" name="coluna" class="form-control dropdown-filtro controles-fitros"
                matTooltip="Pesquise o veículo por" style="min-width: 100px; max-width: 200px;">
                <mat-option value="1">Placa</mat-option>
                <mat-option value="2">Numero Frota</mat-option>
                <mat-option value="3">Modelo</mat-option>
                <mat-option value="4">Código</mat-option>
            </mat-select>
            <mat-select [(ngModel)]="filtro.operador" name="operador" class="form-control dropdown-filtro controles-fitros"
                style="min-width: 100px; max-width: 200px; margin-left: 10px;">
                <mat-option [value]=1>Igual a</mat-option>
                <mat-option [value]=2>Maior que</mat-option>
                <mat-option [value]=3>Menor que</mat-option>
                <mat-option [value]=4>Contendo</mat-option>
                <mat-option [value]=5>Iniciando por</mat-option>
            </mat-select>
            <input type="text" #search required [(ngModel)]="filtro.parametro" name="parametro" id="parametro"
                class="form-control controles-fitros"
                style="margin-left: 10px; min-width: 200px;" matTooltip="Preecha para a pesquisa do veículo"
                #parametro="ngModel" />
            <div [hidden]="parametro.valid || parametro.pristine" style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                <span>Campo é obrigatório</span>
            </div>
            <button type="submit" 
                mat-icon-button style="margin-left: 10px"
                 matTooltip="Pesquise o veículo"
                [disabled]="!filtroForm.form.valid">
                    <mat-icon aria-hidden="false" aria-label="Pesquise veículo" fontIcon="search"></mat-icon>
            </button>
            <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Limpe o resultado da pesquisa de veículo"
                (click)="limpaFiltro()">
                <mat-icon aria-hidden="false" aria-label="Limpe o resultado da pesquisa de veículo" fontIcon="delete">
                </mat-icon>
            </button>
            <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Fechar" (click)="fechar()">
                <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
                </mat-icon>
            </button>
        </div>
    </form>
    <div>
        <mat-form-field class="pesquisa-filtro">
            <input matInput #txtVal (keyup)="applyFilter(txtVal.value)" placeholder="Digite para pesquisar veículo ...">
        </mat-form-field>
    </div>
    <div class="lista-container">
        <mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="placa">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Placa </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.placa}} </mat-cell>
            </ng-container>
            
            <ng-container matColumnDef="modelo">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Modelo </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.modelo}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="numeroFrota">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Nº do Frota </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.numeroFrota}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="codVeiculo">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Código </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.codVeiculo}} </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="getRecord(row)">
            </mat-row>

        </mat-table>

        <mat-paginator #paginator class="filter-paginator" [pageSizeOptions]="[5, 10, 20, 50, 100, 500, 1000, 9999]"
            [pageSize]="5" aria-label="Seleciona a página">
        </mat-paginator>
    </div>
</div>